import type { LibraryListParams, SuggestionParams } from '../../request/evidence-library/evidenceLibraryRequests.ts';

/** Query key registry for the Evidence Library. Everything shares the root so an upload or link refreshes all of it. */

const root = ['evidence-library'] as const;

export const evidenceLibraryQueryKeys = {
  all: root,
  limits: () => [...root, 'limits'] as const,
  list: (params: LibraryListParams) => [...root, 'list', params] as const,
  suggestions: (params: SuggestionParams) => [...root, 'suggestions', params] as const,
} as const;
